/* eslint-disable no-case-declarations */
import * as types from './types';

const initialState = {
  filters: [],
  defaultAssignments: [],
  notificationUsers: [],
  isDefaultAssignmentLoaded: false,
  isNotificationUserLoaded: false,
  checklistTemplates: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_LEADS_STATUSES_SUCCESS:
      const statuses = action.payload;
      const filters = state;

      if (filters.length > 0) {
        // This assumes that the fetched statuses are ordered.
        // Maybe need to manually sort if there are issues.
        const newStatuses = statuses.map(s => {
          const { isEditable, visibility, order, current } = s;
          const filter = filters.find(f => f.id === s.id);
          if (filter) {
            return { ...filter, isEditable, visibility, order, current };
          }
          return s;
        });
        return newStatuses;
      }
      if (statuses.length > 0) {
        return statuses;
      }
      return state;
    case types.UPDATE_STATUSES_SUCCESS:
      const { id, name, current } = action.payload;
      if (action.actionType === 'update') {
        // Update the item in the redux store from mutation results.
        const newStatuses = state.map(s => {
          if (s.id === id) {
            return { ...s, name, current };
          }
          return { ...s };
        });
        return newStatuses;
      }
      if (action.actionType === 'delete') {
        // Remove the item in the redux store from mutation results.
        const newStatuses = state.filter(s => s.id !== id);

        // Ensure the order is sorted for status array when putting back into redux store.
        return newStatuses.sort((a, b) => a.order - b.order);
      }
      // Full list of statuses is in the payload when creating.
      return action.payload;
    case types.REORDER_LEADS_STATUSES_SUCCESS:
      const reorderedStatuses = action.payload.map(s => {
        const foundStatus = state.find(status => status.id === s.id);
        if (foundStatus) return { ...foundStatus, order: s.order };
        // #TODO: Need to fetch custom status if not found. Should never happen,
        // but is just an extra safeguard.
        return null;
      });
      return reorderedStatuses.sort((a, b) => a.order - b.order);
    case types.REORDER_LEADS_STATUSES:
      // Falls through.
    case types.REORDER_LEADS_STATUSES_FAIL:
      // Falls through.
    case types.UPDATE_STATUSES_FAIL:
      return state;
    case types.GET_DEFAULT_ASSIGNMENTS:
      return {
        ...state,
        defaultAssignments: action.payload,
        isDefaultAssignmentLoaded: true,
      };
    case types.GET_INCOMING_NOTIFICATION_USERS:
      return {
        ...state,
        notificationUsers: action.payload,
        isNotificationUserLoaded: true,
      };
    case types.UPDATE_DEFAULT_ASSIGNMENTS_SUCCESS:
      return {
        ...state,
        defaultAssignments:
          state.defaultAssignments.map(m => ({
            ...m,
            isDefaultLeadAssignment: action.action === 'set'
              ? m.loginId === action.payload.loginId ? true : m.isDefaultLeadAssignment
              : m.loginId === action.payload.loginId ? false : m.isDefaultLeadAssignment,
          })),
      };
      case types.UPDATE_INCOMING_NOTIFICATION_SUCCESS:
        return {
          ...state,
          notificationUsers:
            state.notificationUsers.map(m => {
              const orgLeadContact = action.action === 'set' ? action.payload : null;
              return {
                ...m,
                isLeadContact: action.action === 'set'
                  ? m.loginId === action.payload.loginId ? true : m.isLeadContact
                  : m.loginId === action.payload.loginId ? false : m.isLeadContact,
                orgLeadContact: action.action === 'set'
                  && m.loginId === action.payload.loginId ? orgLeadContact : m.orgLeadContact,
              };
            }),
        };
      case types.UPDATE_DEFAULT_ASSIGNMENTS_FAIL:
      case types.UPDATE_INCOMING_NOTIFICATION_FAIL:
        return state;

      case types.ADD_LEAD_CHECKLIST_TEMPLATES:
        return { ...state, checklistTemplates: action.payload.data };
      default:
        return state;
  }
};
